import './App.css';
import './index.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CustomContainer from "./components/layout/container";
import Home from "./Home/Home";
import Who from "./who/whoSubPage"
import Why from "./why/whySubPage"
import What from "./what/whatSubPage"
import How from "./how/howSubPage"
import Team from "./team/teamSubPage"
import TermsAndConditions from "./about/terms-and-conditions"
import Subscribe from "./subscribe/subscribeSubPage"
// Case Studies
import DASCaseStudy from "./why/case-study/DAS"
import IDEACaseStudy from "./why/case-study/iDEA"
import MissanOilCaseStudy from "./why/case-study/MissanOil.js"
import BaowuSteelCaseStudy from "./why/case-study/BaowuSteel.js"
import SenaryoCaseStudy from "./why/case-study/Senaryo.js"
import AMBSCaseStudy from "./why/case-study/AMBSexecEd"
import SAICaseStudy from "./why/case-study/SAI"
import SalfordCaseStudy from "./why/case-study/Salford"
// Risk Stories
// import MissanOil_CSt from "./riskStories/MissanOil_CSt.js"
import RiskStoriesSubPage from "./RiskStories/RiskStoriesSubPage.js"
//
import Layout from './components/layout';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './utils/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/who/:whoSubPage" element={<Who />} />
            <Route path="/why/:whySubPage" element={<Why />} />
            <Route path="/what/:whatSubPage" element={<What />} />
            <Route path="/how/:howSubPage" element={<How />} />
            <Route path="/team/:teamSubPage" element={<Team />} />
            <Route path="/subscribe/:subscribeSubPage" element={<Subscribe />} />
            <Route path="/about/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/why/case-study/DAS" element={<DASCaseStudy />} />
            <Route path="/why/case-study/AMBSexecEd" element={<AMBSCaseStudy />} />
            <Route path="/why/case-study/MissanOil" element={<MissanOilCaseStudy />} />
            <Route path="/why/case-study/BaowuSteel" element={<BaowuSteelCaseStudy />} />
            <Route path="/why/case-study/Senaryo" element={<SenaryoCaseStudy />} />
            <Route path="/why/case-study/iDEA" element={<IDEACaseStudy />} />
            <Route path="/why/case-study/SAI" element={<SAICaseStudy />} />
            <Route path="/why/case-study/Salford" element={<SalfordCaseStudy />} />
            {/* Add other routes as needed */}
            <Route path="/RiskStories/:RiskStoriesSubPage" element={<RiskStoriesSubPage />} />
            {/* Add other routes as needed */}
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
};

export default App;
